import React, { useContext, useEffect, useState } from 'react';

import { fbmSubstitutionRulesV1Api } from 'api/fbmSubstitutionRulesV1';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';

function ViewSubstitutionRules() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const { fbmAccount } = useContext(UserContext);
    const fbmAccountName = fbmAccount?.fbmAccountName;

    const getRows = async () => {
        const response = await fbmSubstitutionRulesV1Api.getRules(fbmAccountName);

        if (response.status === false) {
            setNotification({ text: `No substitution rules found: ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data?.rows ?? []);
    };

    useEffect(() => {
        if (fbmAccount?.id) {
            getRows();
        } else {
            setRows([]);
        }
    }, [fbmAccount]);

    const columns = [
        { accessor: 'originalExternalSku', Header: 'Original External SKU' },
        { accessor: 'originalName', Header: 'Original Name' },
        { accessor: 'substituteExternalSku', Header: 'Substitute External SKU' },
        { accessor: 'substituteName', Header: 'Substitute Name' },
        { accessor: 'substituteQuantity', Header: 'Substitute Quantity' },
    ];

    return (
        <div className="mt-4">
            <h2 className="mb-4 text-lg font-semibold">
                {fbmAccount?.companyName ? `${fbmAccount.companyName} - Substitution Rules` : 'Substitution Rules'}
            </h2>
            <Notifications options={notification} />
            {!fbmAccountName ? (
                <p className="text-sm text-muted-foreground">
                    Please select an FBM account above to view substitution rules.
                </p>
            ) : (
                <DataTable columns={columns} data={rows} />
            )}
        </div>
    );
}

export { ViewSubstitutionRules };
